import { PageType } from '@uno/common-cms';

var filterDisplayableUrls = function filterDisplayableUrls(urls) {
  return urls.filter(function (_ref) {
    var pageType = _ref.pageType;
    return pageType === PageType.FullPage;
  });
};

export default filterDisplayableUrls;